import React from 'react';

import { usePushPermissionAsk } from '../../hooks/push/usePushPermissionAsk';

import { PushPermissionDialog } from './PushPermissionDialog';

export const PushPermissionAsk: React.FC = () => {
  const ask = usePushPermissionAsk();
  return <PushPermissionDialog open={ask.open} stillComes={ask.stillComes} onAllow={ask.allow} onNotNow={ask.notNow} />;
};
